export const One = () => {
  return (
    <svg
      width={31}
      height={41}
      viewBox="0 0 31 41"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M20.165 39.998l-5.039-11.203-.81-1.35 10.663-4.14 5.31 11.654-6.12.944-4.004 4.095z"
        fill="#127FBE"
        stroke="#000"
        strokeWidth={0.0899832}
      />
      <path
        d="M.83 36.586L4.36 24.82l.272-1.55L15.4 27.125l-3.62 12.283-5.243-3.293-5.708.471z"
        fill="#127FBE"
        stroke="#000"
        strokeWidth={0.0899832}
      />
      <circle cx={14.3171} cy={14.3073} r={14.3073} fill="#FFCC5B" />
      <path
        d="M13.957 28.615V0C9.053 0-.54 3.392.035 14.802c.575 11.41 9.348 13.813 13.922 13.813z"
        fill="#FDBC4B"
      />
      <path
        d="M4.779 11.293c-1.065 3.03-1.152 9.844 7.018 12.868M23.855 17.547c1.065-3.03 1.152-9.844-7.019-12.868"
        stroke="#EC9922"
        strokeWidth={0.719866}
        strokeLinecap="round"
      />
      <path
        d="M10.7 10.7V7.644h5.32v14.024h-3.419v-10.97H10.7z"
        fill="#EC9922"
      />
    </svg>
  );
};
